const PUBLIC_PRODUCTION_HOSTS = new Set(['lovibook.com', 'www.lovibook.com']);

/**
 * Returns true when the app is running on the public production marketing host.
 */
export function isPublicProductionHost(hostname?: string): boolean {
  if (!hostname || hostname.trim().length === 0) {
    return false;
  }

  return PUBLIC_PRODUCTION_HOSTS.has(hostname.trim().toLowerCase());
}
